import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { sortSearchParam } from '@/components/data-table/tableSort';
import { weekSearchParam } from '@/features/timesheet/model/searchParams';
import { ReviewPage } from '@/features/timesheet/review/ReviewPage';

export const Route = createFileRoute('/_authenticated/attendance/review')({
  validateSearch: z.object({
    week: weekSearchParam,
    by: z.enum(['person', 'project']).default('person'),
    q: z.string().optional(),
    project: z.array(z.string()).optional(),
    status: z.array(z.enum(['submitted', 'approved'])).optional(),
    s: sortSearchParam,
  }),
  component: function AttendanceReview() {
    const { week, by, q, project, status, s } = Route.useSearch();
    return <ReviewPage week={week} by={by} q={q} project={project} status={status} s={s} />;
  },
});
